import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import 'react-tabs/style/react-tabs.css';
import './Calculator.css';
import { saveAs } from 'file-saver';



import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import { loadCalculationSetting,
  loadCalculationResult,
  loadClaimInSystemList,
  updatePackgeFileName,
  setCaseCalculationInformation,
  loadCalculationSetting2,
  loadUnitTest,
  loadPackageFromFile } from 'ducks/calculator';


import Button from 'jsx/elements/buttons/Button';





import FileLoadModal from './Modals/FileLoadModal';

import CalculateDatesBox from './Boxes/CalculateDatesBox';
import NoCaseSelectedBox from './Boxes/NoCaseSelectedBox';
import ClaimInfo from './Tags/ClaimInfo';




// import {TempData,TempData2, TempData3, TempData4, TempData5} from './TempData';

import MainResultTab from './Tabs/MainResultTab';
import LineResultTab from './Tabs/LineResultTab';
import SettingsTab from './Tabs/SettingsTab';



class CalculationPage extends React.Component {
  state = {
    isPackageModalOpen : false,
    calculateToDate : moment(),
    principalsTo : moment(),
    mainTabSelected : 0
  };

  constructor(props){
    super(props);
    this.onCalculateClick = this.onCalculateClick.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.onAcceptFile = this.onAcceptFile.bind(this);
    this.onOpenCaseFileClick = this.onOpenCaseFileClick.bind(this);
    this.onChangeDates = this.onChangeDates.bind(this);
    this.onCreateUnitTestClick = this.onCreateUnitTestClick.bind(this);
    this.onSavePackageFileClick = this.onSavePackageFileClick.bind(this);
  }

  componentDidMount(){
    this.props.loadClaimInSystemList();

    // this.props.loadCalculationSetting2(TempData4()).then(()=>{
    //   this.props.loadCalculationResult(TempData4());
    // });
      
  }


  onCreateUnitTestClick(){
    this.props.loadUnitTest(this.props.claimSetting).then(()=>{
      //Open some save window and save the file.
      let date_file = new Date();
      let name =  date_file.getDate() + '_' + (date_file.getMonth()+ 1) + '_' +  date_file.getFullYear()+ '_' + date_file.getHours() + '_' + date_file.getMinutes();
      let filename = 'Unit_Test_' + this.props.claimSetting.claimNumber + '_' + name + '.cs';
      let blob = new Blob([this.props.unitTest], {type: "text/plain;charset=utf-8"});
      saveAs(blob, filename);
    });
  };

  onSavePackageFileClick(){
    console.debug("test", this.props.claimSetting);
    //Open some save window and save the file.
    let date_file = new Date();
    let name =  date_file.getDate() + '_' + (date_file.getMonth()+ 1) + '_' +  date_file.getFullYear()+ '_' + date_file.getHours() + '_' + date_file.getMinutes();
    let filename = 'Package_' + this.props.claimSetting.claimNumber + '_' + name + '.cpk';
    let jsonStr = JSON.stringify(this.props.claimSetting);
    console.debug("jsstr", jsonStr[0], jsonStr[1], jsonStr[2]);

    let blob = new Blob([jsonStr], {type: "text/plain;charset=utf-8"});
    saveAs(blob, filename);    
  };



  onOpenCaseFileClick(){
    this.setState({isPackageModalOpen : true});
  };

  onCloseModal() {
    this.setState({isPackageModalOpen : false});
  };

  onAcceptFile(selection, item) {
    this.setState({isPackageModalOpen : false,
                    mainTabSelected : 0}, ()=>{      
        switch(selection){
          case 0:
            //Hlaða upp eftir ID
            this.props.loadCalculationSetting(item);
            break;
          case 1:
            // Hlaða upp eftir claimNumber, sem er í raun ID
            console.log("ITEM", item);
            this.props.loadCalculationSetting(item);
            break;
          case 2:
            //Hlaða upp eftir skrá.
            this.props.loadPackageFromFile(item).then(()=>{
              this.props.updatePackgeFileName(item.name);
            });
            break;
        }
      }
    );
  };

  onChangeDates(name, value) {
    if (name === "calculateToDate"){
      this.setState({ calculateToDate: value });
    }
    else if (name === "principalsTo")
    {
      this.setState({ principalsTo: value });
    }
  }

  onCalculateClick(calculateTo,principalsTo, calledIn, calledBecauseOfDefault ){
     if (this.props.isPackageLoaded) {
      this.props.setCaseCalculationInformation(calculateTo,principalsTo, calledIn, calledBecauseOfDefault).then(()=>{
        this.props.loadCalculationResult(this.props.claimSetting).then(()=>{
          if (this.props.isCalculated){
            this.setState({mainTabSelected : 1});
          }
        })
      });
     }
  }


  render() {

    let claimData = this.props.claimSetting;
    let result = this.props.claimResult;

    // const marginStyle = 
    // {
    //   margin: '5px'
    // };

 
  
    return (
      <section className="section">
        <div className="padded calc-section">
            <div className="grid">            
              <div className="col s1of12">
                <Button  color="gray-light" icon="custom-file01" iconRight text="Opna mál" noMargin  onClick={this.onOpenCaseFileClick} />
              </div>
              <div className="col s7of12">              
                {this.props.isPackageLoaded &&               
                <div>
                  <CalculateDatesBox data={claimData} onCalculate={this.onCalculateClick} onChangeDate={this.onChangeDates}/> 
                  <br/>
                  <ClaimInfo claimnumber={claimData.claimNumber} calculationtime={result.calculationTime} filename={this.props.packageFileName}/>                  
                </div>
                }                       
                {!this.props.isPackageLoaded && <NoCaseSelectedBox/>}                                             
                <br/>                       
              </div>
              <div className="col s2of12">
                {this.props.isPackageLoaded && <Button color="gray-light" icon="custom-file02" iconRight text="Útbúa forritunar einingapróf" onClick={this.onCreateUnitTestClick} />}
              </div>
              <div className="col s2of12">
                {this.props.isPackageLoaded && <Button color="gray-light" icon="custom-file02" iconRight text="Vista pakka með stillingum" onClick={this.onSavePackageFileClick} />}
              </div>



            </div>
            <div className="grid">            
              <div className="col s1of1">
                {this.props.isPackageLoaded &&
                <Tabs selectedIndex={this.state.mainTabSelected} onSelect={index =>  this.setState({mainTabSelected : index}) }>
                  <TabList>
                    <Tab>Stillingar</Tab>
                    {this.props.isCalculated && <Tab>Niðurstaða</Tab>}
                    {this.props.isCalculated && <Tab>Nánar</Tab>}
                  </TabList>                  
                  <TabPanel><SettingsTab claimData={claimData} result={result} calculateToDate={this.state.calculateToDate} oldestDueDate={this.props.oldestDueDate}/> </TabPanel>
                  {this.props.isCalculated && <TabPanel><MainResultTab claimData={claimData} result={result}/> </TabPanel> }
                  {this.props.isCalculated && <TabPanel><LineResultTab claimData={claimData} result={result}/> </TabPanel>}
                </Tabs>}
              </div>
            </div>          
        </div>
        <FileLoadModal isOpen={this.state.isPackageModalOpen} onCloseModal={this.onCloseModal} onAcceptFile={this.onAcceptFile} claimList={this.props.claimInSystemList}/>
      </section>
    );
  }
}

CalculationPage.propTypes = {
  claimSetting : PropTypes.object,
  claimResult : PropTypes.object,
  isPackageLoaded : PropTypes.bool,
  packageFileName: PropTypes.string,
  claimInSystemList : PropTypes.array,
  oldestDueDate : PropTypes.object,
  unitTest : PropTypes.string,
  isCalculated : PropTypes.bool
};

const mapState = ({ calculator }) => ({
  isPackageLoaded : calculator.isPackageLoaded,
  claimSetting : calculator.claimSetting,
  claimResult : calculator.claimResult,
  packageFileName : calculator.packageFileName,
  claimInSystemList : calculator.claimInSystemList,
  oldestDueDate : calculator.oldestDueDate,
  unitTest : calculator.unitTest,
  isCalculated : calculator.isCalculated
});

const mapDispatch = dispatch => ({
  loadCalculationSetting: bindActionCreators(loadCalculationSetting, dispatch),
  loadCalculationResult: bindActionCreators(loadCalculationResult, dispatch),
  loadClaimInSystemList: bindActionCreators(loadClaimInSystemList, dispatch),
  loadPackageFromFile : bindActionCreators(loadPackageFromFile, dispatch),
  updatePackgeFileName : bindActionCreators(updatePackgeFileName, dispatch),
  loadCalculationSetting2 : bindActionCreators(loadCalculationSetting2, dispatch),
  loadUnitTest : bindActionCreators(loadUnitTest, dispatch),
  setCaseCalculationInformation : bindActionCreators(setCaseCalculationInformation, dispatch)
});

export default withRouter(connect(mapState, mapDispatch)(CalculationPage));




// WEBPACK FOOTER //
// ./src/pages/Calculation/index.js